import { Component } from '@angular/core';
import { filter, map, shareReplay, startWith, switchMap, take } from 'rxjs/operators';
import { AuthService } from './auth.service';


@Component({
  selector: 'app-unauthorized',
    template: `

<tcc-simplePanel size="small">
  <div panel-header>Welcome!</div>
  <div panel-body>
    <ng-container *ngIf="!(isLoggedIn$ | async); else loggedIn">
      <p>Please log in to access this application.</p>
      <p>
        <button class="btn btn-primary" (click)="login()">
          Log In
        </button>
      </p>
    </ng-container>
    <ng-template #loggedIn>
      <p>
        You are logged in and should be able to use the application.
      </p>
      <button class="btn btn-primary" routerLink="/" *ngIf="!(redirecting$ | async)">
        Home
      </button>
    </ng-template>
  </div>
</tcc-simplePanel>
`
})
export class UnauthorizedComponent {

  readonly isLoggedIn$ = this.authSvc.authorizedAccount$.pipe(map(x => !!x), shareReplay(1));

  readonly redirecting$ = this.isLoggedIn$.pipe(
    filter(x => x),
    take(1),
    switchMap(() => this.authSvc.doPostLoginRedirect()),
    startWith(false)
  );
  constructor(private authSvc: AuthService) { }

  login(): void {
    this.authSvc.login().subscribe();
  }
}
